import { useHubSlug } from "./useHubSlug";

export function useCountryCode() {
  const hubSlug = useHubSlug();
  const [countryCode] = hubSlug!.split("_");

  return countryCode;
}
